export enum ROLES {
    SUPER_ADMIN = 0,
    ADMIN = 1,
    USER = 2,
    CLIENT = 3,
}
